
export const FETCH_SUBMITTED_FOR_VERIFICATION = "[MRT] FETCH_SUBMITTED_FOR_VERIFICATION";
export const FETCH_SUBMITTED_FOR_VERIFICATION_START = "[MRT] FETCH_SUBMITTED_FOR_VERIFICATION_START";
export const FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS = "[MRT] FETCH_SUBMITTED_FOR_VERIFICATION_SUCCESS";
export const FETCH_SUBMITTED_FOR_VERIFICATION_ERROR = "[MRT] FETCH_SUBMITTED_FOR_VERIFICATION_ERROR";

export const SET_MRT_SFV_FILTER = "[MRT] SET_MRT_SFV_FILTER";

export const SET_SFV_AUTO_NEXT_VISIT = "[MRT] SET_SFV_AUTO_NEXT_VISIT";

export const UNDO_REVIEWING_REPORT = "[MRT] UNDO_REVIEWING_REPORT";
export const UNDO_REVIEWING_REPORT_START = "[MRT] UNDO_REVIEWING_REPORT_START";
export const UNDO_REVIEWING_REPORT_SUCCESS = "[MRT] UNDO_REVIEWING_REPORT_SUCCESS";
export const UNDO_REVIEWING_REPORT_ERROR = "[MRT] UNDO_REVIEWING_REPORT_ERROR";
export const SET_SUBMITTED_FOR_VERIFICATION_PAGINATION = "[MRT] SET_SUBMITTED_FOR_VERIFICATION_PAGINATION";

export const VIEW_SFV_VISIT_LOADING_START = "[MRT] VIEW_SFV_VISIT_LOADING_START";
export const VIEW_SFV_VISIT_LOADING_END = "[MRT] VIEW_SFV_VISIT_LOADING_END";
export const RESET_SFV_FILTER = "[MRT] RESET_SFV_FILTER";


export const fetchSubmittedForVerification = (payload) => {
    return {
        type: FETCH_SUBMITTED_FOR_VERIFICATION,
        payload
    };
};

export const setMrtSFVFilter = (searchFilter, sortConditions, skippedVisits) => {
    return {
        type: SET_MRT_SFV_FILTER,
        payload: {
            searchFilter,
            sortConditions,
            skippedVisits
        }
    };
}

export const setSfvAutoNextVisit = (autoNextVisit) => {
    return {
        type: SET_SFV_AUTO_NEXT_VISIT,
        autoNextVisit
    }
}

export const undoReviewingReport = (reportId) => {
    return {
        type: UNDO_REVIEWING_REPORT,
        payload: {
            reportId
        }
    };
};

export const resetSFVFilter = () => {
    return {
        type: RESET_SFV_FILTER,
    };
}
